import { VStack } from '@chakra-ui/layout'
import { Box, Text as ChakraText } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BiExport, BiImport } from "react-icons/bi"
import { GrImage as GrImageIcon } from 'react-icons/gr'
import styled, { createGlobalStyle } from 'styled-components'
import { colors } from '../../../ui-kit'
import { SideBar } from '../../layouts/Base'
import { SideBarItem } from '../../layouts/Base/SideBar'


const GrImage = styled(GrImageIcon)`
  path {
    stroke: ${props => props.stroke};
  }
`

const ActiveLinkStyles = createGlobalStyle`
  .active-link {
    ${GrImage} {
      path {
        stroke: ${colors.appSlate};
      }
    }

    :not(${GrImage}) {
      svg {
        fill: ${colors.appSlate};
      }
    }
    p {
      color: ${colors.appSlate};
    }
  }
`


export const SideMenu = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <SideBar heading={t('labs', 'Labs')}>
      <ActiveLinkStyles />
      <VStack
        overflow="auto"
        h="100%"
        spacing="1em"
        padding="1.5em 0.75em 1.5em"
      >
        <SideBarItem to="/labs/export-folder-csv" activeClassName="active-link">
          <Box margin="1rem">
            <BiImport fontSize="2rem" fill={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color="appBattleshipGrey"
            lineHeight="4rem"
          >
            Export files as CSV
          </ChakraText>
        </SideBarItem>
        <SideBarItem to="/labs/bulk-update-csv" activeClassName="active-link">
          <Box margin="1rem">
            <BiExport fontSize="2rem" fill={colors.appBattleshipGrey} />
          </Box>
          <ChakraText
            fontSize="md"
            fontWeight="500"
            color="appBattleshipGrey"
            lineHeight="4rem"
          >
            Update files from CSV
          </ChakraText>
        </SideBarItem>
      </VStack>
    </SideBar>
  )
}
